const icon = new URL('../../icons/stock-hub.png', import.meta.url).href

export default {
  type: 'stock-hub',
  description: 'stock data hub',
  group: 'warehouse' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'stock-hub',
    left: 100,
    top: 100,
    width: 60,
    height: 60
  }
}
